import Quill from "quill"

// We override the default Uploader
// See packages/quill/src/modules/uploader.ts
class OverrideUploader {
  constructor(_quill, _options) {
    // do nothing
  }
}
Quill.register("modules/uploader", OverrideUploader, true)
